import { createContext, ReactNode, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { ErrorFallbackScreen } from 'components/screens';
import { useAccessToken } from 'utils/auth';
import { logError } from 'utils/datadog';
import { useShiftQuery } from '../query';
import { ShiftContextState } from '../types';

export const ShiftContext = createContext<ShiftContextState | undefined>(
  undefined
);

export const ShiftContextProvider = ({ children }: { children: ReactNode }) => {
  const { token } = useAccessToken();
  const { shiftId } = useParams();

  const { data, isError, error, isLoading } = useShiftQuery(token, shiftId);

  const contextValue = useMemo(
    () => ({
      shift: data?.data,
      isLoading,
      isError: !!(token && !data?.data)
    }),
    [token, data?.data, isLoading]
  );

  if (isError) {
    logError('Shift query error', error);
    return <ErrorFallbackScreen />;
  }

  return (
    <ShiftContext.Provider value={contextValue}>
      {children}
    </ShiftContext.Provider>
  );
};
